import { render, staticRenderFns } from "./impedance.vue?vue&type=template&id=21124398&scoped=true"
import script from "./impedance.vue?vue&type=script&lang=js"
export * from "./impedance.vue?vue&type=script&lang=js"
import style0 from "./impedance.vue?vue&type=style&index=0&id=21124398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21124398",
  null
  
)

export default component.exports